// This is for variant-picker-color.liquid
var VariantPickerColor = (() => {
	var open = (container) => {
		const sectionContainer = container.closest('[js-section-container]');
		if (sectionContainer) {
			sectionContainer.querySelectorAll('[js-color-option-unit]').forEach(element => {
				close(element);
			});
		}
		container.classList.add('open');
		const varaintDetailContainer = container.querySelector('[js-variant-detail]');
		if (!varaintDetailContainer) return;
		varaintDetailContainer.style.maxHeight = varaintDetailContainer.scrollHeight + 2 + 'px';
		container.style.paddingBottom = varaintDetailContainer.scrollHeight + 2 + 'px';
	}
	var close = (container) => {
		container.classList.remove('open');
		const varaintDetailContainer = container.querySelector('[js-variant-detail]');
		if (!varaintDetailContainer) return;
		varaintDetailContainer.style.maxHeight = '0px';
		container.style.paddingBottom = '0px';
	}
	var getSectionsToRender = () => {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }
	var getSectionInnerHTML = (html, selector = '.shopify-section') => {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
	var renderContents = (parsedState) => {
    document.querySelector('.drawer__inner').classList.contains('is-empty') && document.querySelector('.drawer__inner').classList.remove('is-empty');
    // this.productId = parsedState.id;
    getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer)
      	cartDrawer.open();
    });
  }
	var addToCart = (container, element) => {
		element.classList.add('loading');
		const variantId = container.getAttribute('data-variant-id');
		const quantityElement = container.querySelector('input[name="quantity"]');
		if (!quantityElement) return;
		const quantity = parseInt(quantityElement.value);
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				id: variantId,
				quantity: quantity,
				sections: getSectionsToRender().map((section) => section.id)
			}),
		})
		.then(response => response.json())
		.then(data => {
			element.classList.remove('loading');
			renderContents(data);
		})
		.catch((error) => {
			element.classList.remove('loading');
			console.error('Error:', error);
		});
	}
	var initialize = () => {
		document.querySelectorAll('[js-color-option-unit] [js-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				const container = element.closest('[js-color-option-unit]');
				if (!container) return;
				if (container.classList.contains('open')) close(container);
				else open(container);
			});
		});
		document.querySelectorAll('[js-add-to-cart-variant]').forEach(element => {
			element.addEventListener('click', () => {
				const container = element.closest('[js-atc]');
				if (!container) return;
				if (!element.classList.contains('disabled'))
					addToCart(container, element);
			});
		});
	}
	return {
		init: initialize
	}
})();

var App = (() => {
  var initialize = () => {
		VariantPickerColor.init();
	}
	return {
		init: initialize
	}
})();

document.addEventListener('DOMContentLoaded', () => {
	App.init();
});